export const SupportedLanguages = Object.freeze({
  ENGLISH: 'en-US',
  ESPANOL: 'es-ES',
  CHINESE: 'zh-CN',
} as const);

export const SupportedLanguagesArray = Object.values(SupportedLanguages);

export function isSupportedLanguage(lang: string): lang is SupportedLanguages {
  return SupportedLanguagesArray.includes(lang as SupportedLanguages);
}

export type SupportedLanguages = (typeof SupportedLanguages)[keyof typeof SupportedLanguages];
